import React, { Fragment } from 'react';
import { Flex, Text, Button, Box } from 'rebass';
import ScrollAnimation from 'react-animate-on-scroll';
import styled from 'styled-components';
import thyroidIcon from '../static/thyroid.png';
import iconBackgroundShape from '../static/iconBackgroundShape.png';
import withSession from '../lib/withSession';
import { withRouter } from 'react-router-dom';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
  padding-bottom: 96px;
`;

const Biomarker = styled.div`
  border-radius: 15px;
  border: 1px solid #f1a493;
  color: #344f79;
  display: inline-block;
  margin-right: 12px;
  padding: 5px 16px;
  position: relative;
`;

const Tooltip = styled.div`
  position: absolute;
  z-index: 3;
  display: none;
  width: 250px;
  min-height: 5px;
  padding: 10px;
  border-radius: 30px;
  background-color: #344f79;
  bottom: 120%;
  left: -108px;
  font-weight: 300;
  color: white;
  padding: 10;
  text-align: center;
  font-size: 14px;
  ${Biomarker}:hover & {
    display: block;
  }
`;

const Image = styled.div`
  &::before {
    float: left;
    border-radius: 0px;
    background-image: url(${iconBackgroundShape});
    background-position: 0px 0px;
    background-size: contain;
    background-repeat: no-repeat;
    content: '';
    position: absolute;
    height: 110px;
    width: 100%;
  }
`;

const DesktopOnly = styled(Flex)`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const MobileView = styled(Flex)`
  flex: 1;
  justify-content: center;

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const B2BRestricted = (props) => (
  <Fragment>
    {/* {props.patientState && props.patientState.level && props.patientState.level !== 'none' ? ( */}
    <Container>
      <Flex flex={1} mr={[0, 0, 0]} mb={3}>
        <ScrollAnimation animateIn="fadeInUpFrom40" animateOnce={true} style={{ textAlign: 'center', height: '100%', width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <img
              alt=""
              src={thyroidIcon}
              style={{
                width: '200px',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                marginBottom: '24px',
              }}
            />
          </div>
          <Text fontSize="38px" fontWeight={600} mb={3} textAlign="center" color="#344f79" lineHeight="44px" style={{ fontFamily: 'Playfair Display' }}>
            We’re Sorry {props && props.session ? `${props.session.firstName}` : ''},
          </Text>
          <Text textAlign="center" lineHeight="30px" mt={4} fontSize="18px" fontWeight={200} color="#344f79" mb="36px">
            Unfortunately, your provider restricted your access to this type of visits.
            <br />
            <br /> Click below to view your allowed visits
          </Text>
          <Button
            variant={'primary'}
            onClick={() => {
              props.history.push('/schedule-split');
            }}
          >
            Go to visits
          </Button>

          <Flex style={{ gap: 24 }} mt={4} mb={4} alignItems={'center'}>
            <Flex style={{ height: '1px', background: '#344f79', flex: 1 }} />
            <Text textAlign="center" fontSize="18px" fontWeight={200} color="#344f79">
              OR
            </Text>
            <Flex style={{ height: '1px', background: '#344f79', flex: 1 }} />
          </Flex>

          <Button
            variant={'primary'}
            onClick={() => {
              props.history.push('/');
            }}
          >
            Go to dashboard
          </Button>
        </ScrollAnimation>
      </Flex>
    </Container>
    {/* )} */}
  </Fragment>
);

export default withSession(withRouter(B2BRestricted));
